import { PropertyValuePipe } from './pipes/property-value.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalcAgePipe } from './pipes/calc-age.pipe';
import { IsTruthyPipe } from './pipes/truthy.pipe';
import { ClickStopPropagationDirective } from './directives/click-stop-propagation/src/lib/click-stop-propagation.directive';
import { SanitizeImagePipe } from './pipes/sanitize-image.pipe';
import { TextSelectionDirective } from './directives/text-selection/src/lib/text-selection.directive';
import { HighlighterPipe } from './pipes/highlighter.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    PropertyValuePipe,
    CalcAgePipe,
    IsTruthyPipe,
    ClickStopPropagationDirective,
    SanitizeImagePipe,
    TextSelectionDirective,
    HighlighterPipe
  ],
  exports: [
    PropertyValuePipe,
    CalcAgePipe,
    IsTruthyPipe,
    ClickStopPropagationDirective,
    SanitizeImagePipe,
    TextSelectionDirective,
    HighlighterPipe
  ],
  providers: [
    PropertyValuePipe,
    CalcAgePipe,
    SanitizeImagePipe
  ]
})
export class SharedUtilsModule { }
